export default __webpack_public_path__ + "static/password-reset-illustration-6b89d11cc725803b7e1c7f4a4420c201.jpg";